import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Slice/authSlice";
import siteReducer from "./Slice/siteSlice";
import productReducer from "./Slice/productSlice";
import orderReducer from "./Slice/orderSlice";

// Redux store: auth (shopper), site (store config), product (catalogue), order (shopper's orders)
export const store = configureStore({
    reducer: {
        auth: authReducer,
        site: siteReducer,
        product: productReducer,
        order: orderReducer,
    },
});

export default store;
